var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-arrow-"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 12.5c0-.28.22-.5.5-.5h15.79l-5.14-5.15a.485.485 0 010-.7c.09-.1.22-.15.35-.15.13 0 .26.05.35.15l6 6c.2.19.2.51 0 .7l-6 6c-.19.2-.51.2-.7 0a.485.485 0 010-.7L19.29 13H3.5c-.28 0-.5-.22-.5-.5",
    id: "right-arrow",
    fill: "#000"
  })))));
}
SvgNext.displayName = 'Next';
export default SvgNext;